import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import SponsorDeck from "@/pages/SponsorDeck";

export const Route = createFileRoute("/sponsor-deck")({
  head: () => seoHead("/sponsor-deck"),
  component: SponsorDeck,
});
